import React from "react";
import { Spacer } from "./Spacer";
import { SpacerBaseProps, SpecializedSpacerComponent } from "./Spacer.types";

/**
 * HorizontalSpacer - Creates horizontal space in layouts
 *
 * @example
 * // Basic usage
 * <HorizontalSpacer size="medium" />
 *
 * // As a custom element
 * <HorizontalSpacer as="span" size={10} />
 */

export const HorizontalSpacer = function HorizontalSpacer(
  props: Omit<SpacerBaseProps, "axis"> & { as?: React.ElementType }
) {
  const { as, ...rest } = props;
  return <Spacer as={as} axis="horizontal" {...rest} />;
} as SpecializedSpacerComponent;

// Set display name for debugging
HorizontalSpacer.displayName = "HorizontalSpacer";

export default HorizontalSpacer;
